export default "__VITE_ASSET__CPKgPUYq__"